import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelect, MatSelectChange, MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { EtiquetteSessionModel } from 'src/models/etiquetteSessionModel';
import { GroupeFormationModel } from 'src/models/groupe-formation/groupe-formation-model';
import { UtilisateurFormationModel } from 'src/models/groupe-formation/utilisateur-formation-model';
import { ScormPackageLocaleModel, ScormPackageModel } from 'src/models/scormPackageModel';
import { EtiquetteService } from 'src/services/etiquette.service';
import { GroupeFormationService } from 'src/services/groupe-formation.service';
import { ScormService } from 'src/services/scorm.service';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-ajouter-modifier-formation-groupe-dialog',
    templateUrl: './ajouter-modifier-formation-groupe-dialog.component.html',
    styleUrls: ['./ajouter-modifier-formation-groupe-dialog.component.scss'],
    imports: [
        MatIconModule,
        CommonModule,
        TranslateModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        MatOptionModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        NgxMatSelectSearchModule,
        MatDatepickerModule,
        MatCheckboxModule
    ]
})
export class AjouterModifierFormationGroupeDialogComponent implements OnInit {
  @ViewChild('superviseurSelect') superviseurSelect!: MatSelect;
  @ViewChild('participantSelect') participantSelect!: MatSelect;
  @ViewChild('etiquetteSelect') etiquetteSelect!: MatSelect;
  @ViewChild('optionSelect') optionSelect!: MatOption;

  selectionScormPackage: string = '';
  selectionSuperviseur: string = '';
  selectionParticipant: string = '';

  scormPackageWithLegalMentions = environment.scormPackageWithLegalMentions.split(",");
  scormPackageTMD = environment.scormPackageTMD.split(",");
  afficherMentionLegale: boolean = false;
  estPasAutoriserEnFormationGroupe: boolean = false;

  formation!: GroupeFormationModel;
  tousUtilisateurs: UtilisateurFormationModel[] = [];

  selectedSuperviseurs: UtilisateurFormationModel[] = [];
  selectedEtiquettes: EtiquetteSessionModel[] = [];
  selectedParticipants: UtilisateurFormationModel[] = [];
  selectionParticipantFiltreEncours: UtilisateurFormationModel[] = [];

  scormPackages: ScormPackageModel[] = [];
  isLoading = true;
  consentementConfirme: boolean = false;

  etiquettes: EtiquetteSessionModel[] = [];
  superviseurs: UtilisateurFormationModel[] = [];
  participants: UtilisateurFormationModel[] = [];

  scormPackagesFilterCtrl = new FormControl('');
  filteredscormPackages: ReplaySubject<ScormPackageModel[]> = new ReplaySubject<ScormPackageModel[]>(1);

  superviseurFilterCtrl = new FormControl('');
  filteredSuperviseurs: ReplaySubject<UtilisateurFormationModel[]> = new ReplaySubject<UtilisateurFormationModel[]>(1);

  etiquetteFilterCtrl = new FormControl('');
  filteredEtiquettes: ReplaySubject<EtiquetteSessionModel[]> = new ReplaySubject<EtiquetteSessionModel[]>(1);

  participantFilterCtrl = new FormControl('');
  filteredParticipants: ReplaySubject<UtilisateurFormationModel[]> = new ReplaySubject<UtilisateurFormationModel[]>(1);

  private _onDestroy = new Subject<void>();

  constructor(
    public router: Router,
    public groupeFormationService: GroupeFormationService,
    public etiquetteService: EtiquetteService,
    public scormService: ScormService,
    public translate: TranslateService,
    private utilisateurService: UtilisateurService,
    public dialogRef: MatDialogRef<AjouterModifierFormationGroupeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GroupeFormationModel
  ) {
    if (this.data != null && this.data.id > 0) {
      this.formation = this.data;
      this.formation.utilisateurs.forEach(user => user.estSelectionne = true);
      this.selectedParticipants = this.formation.utilisateurs.filter(user => user.estSelectionne == true && user.estResponsableFormation == false);
      this.selectionParticipantFiltreEncours = this.selectedParticipants;
      this.selectedSuperviseurs = this.formation.utilisateurs.filter(user => user.estSelectionne == true && user.estResponsableFormation == true);
    } else {
      this.formation = new GroupeFormationModel();
    }
  }

  ngOnInit() {
    this.bindFiltredCtl();
    this.obtenirEtiquettes();
    this.loadScormPackages();
  }

  private bindFiltredCtl() {
    this.participantFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredParticipants();
      });

    this.superviseurFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredSuperviseurs();
      });

    this.etiquetteFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtredEtiquettes();
      });

    this.scormPackagesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filteredscormPackage();
      });
  }

  onSelectionChangeEtiquettes(event: MatSelectChange): void {
    if (event.value == -1) {
      this.selectedEtiquettes = this.etiquettes;
      this.optionSelect.select();
      this.selectAllParticipants();
      return;
    }

    if (!this.selectedEtiquettes.some(etiquette => etiquette.etiquetteId == event.value)) {
      this.selectedEtiquettes.push(this.etiquettes.find(etiquette => etiquette.etiquetteId == event.value)!);
    }

    this.updateParticipantSelonEtiquette();
  }

  updateParticipantSelonEtiquette(): void {
    this.selectedEtiquettes.forEach(etiquette => {
      this.tousUtilisateurs.forEach(user => {
        if (user.estResponsableFormation == false && user.etiquetteIds.includes(etiquette.etiquetteId)) {
          user.estSelectionne = true;
        }
      })
    })
    this.selectedParticipants = this.participants.filter(participant => participant.estSelectionne == true && participant.estResponsableFormation == false);
    this.selectionParticipantFiltreEncours = this.selectedParticipants;
    this.filteredParticipants.next(
      this.participants.filter(participant => participant.estSelectionne == false && participant.estResponsableFormation == false)
    );
  }


  onSelectionChangeScormPackage(event: MatSelectChange): void {
    this.formation.packageId = event.value;
    this.afficherMentionLegale = this.scormPackageWithLegalMentions.includes(this.formation.packageId.toString());
    this.estPasAutoriserEnFormationGroupe = this.scormPackageTMD.includes(this.formation.packageId.toString());
  }
  onSelectionChangeSuperviseur(event: MatSelectChange): void {
    this.updateListSupervisor(event);
  }
  onSelectionParticipantChange(event: MatSelectChange): void {
    this.selectionParticipant = event.value;
    if (this.selectionParticipant === "-1") {
      this.tousUtilisateurs.forEach(participant => {
        if (participant.estResponsableFormation == false) {
          participant.estSelectionne = true;
        }
      });
      this.filtredParticipants();

      return;
    }
    this.updateListParticipant(event);
  }

  updateListSupervisor(event: MatSelectChange): void {
    const selectedId = event.value;
    this.tousUtilisateurs.forEach(user => {
      if (selectedId == user.utilisateurId) {
        user.estSelectionne = true;
        user.estResponsableFormation = true;
        this.superviseurSelect.value = "";
      }
    });
    this.updateListSelection();
  }

  updateListParticipant(event: MatSelectChange): void {
    const selectedId = event.value;
    this.tousUtilisateurs.forEach(participant => {
      if (selectedId == participant.utilisateurId && participant.estResponsableFormation == false) {
        participant.estSelectionne = true;
        this.participantSelect.value = "";
      }
    });
    this.updateListSelection();
  }

  selectAllParticipants() {
    if (this.optionSelect.selected) {
      this.tousUtilisateurs.forEach(participant => {
        if (participant.estResponsableFormation == false) {
          participant.estSelectionne = true;
        }
      });
    } else {
      this.tousUtilisateurs.forEach(participant => {
        if (participant.estResponsableFormation == false) {
          participant.estSelectionne = false;
        }
      });
    }
    setTimeout(() => {
      this.participantSelect.close();
    }, 100);
    this.updateListSelection();
  }

  filtreSelectedParticipants(event: any) {
    if (event.target.value !== '' && event.target.value.length > 2) {
      this.selectionParticipantFiltreEncours = this.selectedParticipants.filter(user => user.prenom?.toLowerCase().includes(event.target.value.toLowerCase()) || user.nom?.toLowerCase().includes(event.target.value.toLowerCase()));
    } else {
      this.selectionParticipantFiltreEncours = this.selectedParticipants;
    }
  }

  updateListSelection() {
    this.selectedSuperviseurs = this.tousUtilisateurs.filter(user => user.estSelectionne == true && user.estResponsableFormation == true);
    this.selectedParticipants = this.tousUtilisateurs.filter(user => user.estSelectionne == true && user.estResponsableFormation == false);
    this.selectionParticipantFiltreEncours = this.selectedParticipants;

    this.filteredSuperviseurs.next(
      this.superviseurs.filter(superviseur => !(superviseur.estSelectionne && superviseur.estResponsableFormation))
    );

    this.filteredParticipants.next(
      this.participants.filter(participant => participant.estSelectionne == false && participant.estResponsableFormation == false)
    );
  }


  removeSupervisor(utilisateurId: number) {
    this.tousUtilisateurs.forEach(user => {
      if (user.utilisateurId == utilisateurId) {
        user.estSelectionne = false;
        user.estResponsableFormation = false;
      }
    })
    this.updateListSelection();
  }

  removeEtiquette(etiquetteId: number) {
    this.selectedEtiquettes = this.selectedEtiquettes.filter(etiquette => etiquette.etiquetteId != etiquetteId);
    this.tousUtilisateurs.forEach(user => {
      if (user.estResponsableFormation == false && user.etiquetteIds.includes(etiquetteId)) {
        user.estSelectionne = false;
        this.etiquetteSelect.value = "";
      }
    })
    this.updateParticipantSelonEtiquette();
  }

  removeParticipant(utilisateurId: number) {
    this.tousUtilisateurs.forEach(user => {
      if (user.utilisateurId === utilisateurId) {
        user.estSelectionne = false;
      }
    });
    this.updateListSelection();
  }

  viderParticipants() {
    this.tousUtilisateurs.forEach(participant => {
      if (participant.estResponsableFormation == false) {
        participant.estSelectionne = false;
      }
    })
    this.updateListSelection();
    this.optionSelect.deselect();
    this.selectedEtiquettes = [];
  }



  private filteredscormPackage() {
    if (!this.scormPackages) {
      return;
    }
    let search = this.scormPackagesFilterCtrl.value;
    if (!search) {
      this.filteredscormPackages.next(this.scormPackages.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredscormPackages.next(
      this.scormPackages.filter(scorm => this.getLocalizedContent(scorm.scormPackageId).titre?.toLowerCase().indexOf(search) > -1)
    );
  }

  private filtredSuperviseurs() {
    if (!this.superviseurs) {
      return;
    }
    let search = this.superviseurFilterCtrl.value;
    if (!search) {
      this.filteredSuperviseurs.next(this.superviseurs.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredSuperviseurs.next(
      this.superviseurs.filter(superviseur => superviseur.nom?.toLocaleLowerCase().indexOf(search) > -1 || superviseur.prenom?.toLocaleLowerCase().indexOf(search) > -1)
    );
  }

  private filtredEtiquettes() {
    if (!this.etiquettes) {
      return;
    }
    let search = this.etiquetteFilterCtrl.value;
    if (!search) {
      this.filteredEtiquettes.next(this.etiquettes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEtiquettes.next(
      this.etiquettes.filter(etiquette => this.etiquetteService.getNomLocalise(etiquette.locales).toLowerCase().indexOf(search) > -1)
    );
  }


  private filtredParticipants() {
    if (!this.participants) {
      return;
    }
    let search = this.participantFilterCtrl.value;
    if (!search) {
      this.filteredParticipants.next(this.participants.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredParticipants.next(
      this.participants.filter(part => part.nom?.toLocaleLowerCase().indexOf(search) > -1 || part.prenom?.toLocaleLowerCase().indexOf(search) > -1)
    );
  }
  getDureeEnMinutes(scormPackageId: number): number | null {
    const scormPackage = this.scormPackages.find(scorm => scorm.scormPackageId === scormPackageId);

    if (!scormPackage) {
      return null;
    }

    const currentLang = this.translate.currentLang || 'fr';
    const locale = scormPackage.locales.find(l => l.langue.toLowerCase() === currentLang) || scormPackage.locales[0];

    return locale?.dureeEnMinutes || null;
  }

  getLocalizedContent(scormPackageId: number): ScormPackageLocaleModel {
    const locales = this.scormPackages.find(scorm => scorm.scormPackageId === scormPackageId)!.locales;
    const currentLang = this.translate.currentLang || 'fr';
    return locales.find(locale => locale.langue.toLowerCase() === currentLang) || locales[0];
  }

  loadScormPackages() {
    this.isLoading = true;
    this.scormService.getAllPackages(this.utilisateurService.entiteUtilisateurSelectionnee.entiteId).subscribe(res => {
    this.scormPackages = res;
    if (this.formation.packageId > 0) {
        this.selectionScormPackage = this.getLocalizedContent(this.formation.packageId).titre;
      }
      this.scormPackages = Array.from(
        new Map(res.map(scorm => [scorm.scormPackageId, scorm])).values()
      );
      this.filteredscormPackages.next(this.scormPackages);
      this.loadUsers();
    });
  }

  obtenirEtiquettes() {
    this.etiquetteService.obtenirEtiquettes().subscribe(res => {
      this.etiquettes = res;
      this.etiquettes = this.etiquettes.sort((a, b) =>
        this.etiquetteService.getNomLocalise(a.locales).localeCompare(
          this.etiquetteService.getNomLocalise(b.locales)
        )
      );
      this.etiquettes = Array.from(
        new Map(res.map(etq => [etq.etiquetteId, etq])).values()
      );
      this.filteredEtiquettes.next(this.etiquettes);
    });
  }

  loadUsers() {
    this.groupeFormationService.ObtenirUtilisateursEntite().subscribe(res => {
      this.tousUtilisateurs = res;
      this.tousUtilisateurs = this.tousUtilisateurs.sort((a, b) => a?.prenom?.localeCompare(b?.prenom!));
      if (this.formation.id > 0) {
        this.mapperFormationGroupeUtilisateur();
      }

      this.mapperFiltres(this.tousUtilisateurs);
      this.isLoading = false;
    })
  }

  private mapperFormationGroupeUtilisateur() {
    this.formation.utilisateurs.forEach(utilisateur => {
      this.tousUtilisateurs.forEach(user => {
        if (user.utilisateurId == utilisateur.utilisateurId) {
          user.formationGroupeUtilisateurId = utilisateur.formationGroupeUtilisateurId;
          user.estPresent = utilisateur.estPresent;
          user.dateAjout = utilisateur.dateAjout;
          user.ajouteParUtilisateurId = utilisateur.ajouteParUtilisateurId;
          user.retireParUtilisateurId = utilisateur.retireParUtilisateurId;
          user.dateRetrait = utilisateur.dateRetrait;
          user.estSelectionne = true;
          user.estResponsableFormation = utilisateur.estResponsableFormation;
        }
      });
    });
  }

  private mapperFiltres(utilisateurs: UtilisateurFormationModel[]) {
    this.participants = Array.from(
      new Map(utilisateurs.map(user => [user.utilisateurId, user])).values()
    );
    this.filteredParticipants.next(this.participants);

    this.superviseurs = Array.from(
      new Map(utilisateurs.map(user => [user.utilisateurId, user])).values()
    );
    this.filteredSuperviseurs.next(this.superviseurs);
  }

  saveTraining() {
    this.isLoading = true;
    this.formation.package = null;
    this.formation.utilisateurs = this.tousUtilisateurs.filter(user => user.estSelectionne == true);
    if (this.formation.id > 0) {
      this.groupeFormationService.ModifierFormationGroupe(this.formation.id, this.formation).subscribe(res => {
        this.dialogRef.close(true);
        this.isLoading = false;
      });
    } else {
      this.groupeFormationService.CreerFormationGroupe(this.formation).subscribe(res => {
        this.dialogRef.close(true);
        this.isLoading = false;
      });
    }
  }

  boutonSauvegardeDesactive(): boolean {
    return this.formation.titre == null ||
      this.formation.titre == '' ||
      this.formation.emplacement == null ||
      this.formation.emplacement == '' ||
      this.formation.dateHeurePrevue == null ||
      this.selectedSuperviseurs.length == 0 ||
      this.selectedParticipants.length == 0 ||
      this.formation.packageId == 0 ||
      this.formation.packageId == undefined ||
      this.estPasAutoriserEnFormationGroupe ||
      !this.consentementConfirme;

  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
